import { takeLatest, put, call } from 'redux-saga/effects';

import * as services from './services';
import Creators, { BalancerMetricsTypes as constants } from './reducer';
import dayjs from 'dayjs'
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

const actions = {
  getBalancerMetricsActions: {
    request: Creators.getBalancerMetricsRequest,
    success: Creators.getBalancerMetricsSuccess,
  },
};

const eventsOptions = {
  [constants.GET_BALANCER_METRICS_REQUEST]: {
    api: services.getMetricsReport,
    actions: actions.getBalancerMetricsActions,
  },
};

function mergeUniqueByTimestamp(a = [], b = []) {
  const seen = new Set()
  const out = []
  const pushIfNew = (item) => {
    const key = item.timestamp
    if (!seen.has(key)) {
      seen.add(key)
      out.push(item)
    }
  }
  a.forEach(pushIfNew)
  b.forEach(pushIfNew)
  return out
}

function* apiGenerator(action) {
  const provider = eventsOptions[action.type];
  try {
    const params = action.payload; // should only contain order
    const response = yield call(provider.api, params);

    if (response.ok && response.data) {
      yield put(provider.actions.success(response.data));
    } else {
      yield put(Creators.balancerMetricsFetchingReset());
    }
  } catch (errors) {
    yield put(Creators.balancerMetricsFetchingReset());
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_BALANCER_METRICS_REQUEST, apiGenerator);
}
